import { render, staticRenderFns } from "./carbonfootprintReport.vue?vue&type=template&id=cc309dac&scoped=true"
import script from "./carbonfootprintReport.vue?vue&type=script&lang=js"
export * from "./carbonfootprintReport.vue?vue&type=script&lang=js"
import style0 from "./carbonfootprintReport.vue?vue&type=style&index=0&id=cc309dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc309dac",
  null
  
)

export default component.exports